import gql from 'graphql-tag';
export default gql`
  mutation getEnvelopeMLA($applicationId: String!) {
    getEnvelopeMLA(applicationId: $applicationId) {
      status
    }
  }
`;
